// ideally, in React land, you should not use this check. Instead, you should
// use a Provider/Consumer patter to pass data to your component. Client and
// Server can each populate the Provider however they want, which allows your
// component to consume the data without a client/server check. some day...

export const isSSR = () => typeof window === "undefined";
